import { __decorate, __metadata } from "tslib";
import { SessionQuery, SessionService, SessionUserTypeService } from '@ho/shared/data-access/session';
import { AppEnvironment } from '@ho/shared/data-access/core/app-environment.model';
import { Inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { SnackbarService } from '@ho/shared/ui/snack-bar';
import { Observable, of } from 'rxjs';
import { DOCUMENT } from '@angular/common';
import { map as _map } from 'lodash-es';
import { parseQueryParams, prepareQueryParams } from '@ho/libs/shared/services/query-params.helper';
let AuthGuardService = class AuthGuardService {
    constructor(_authQuery, _authService, _router, _snack, _sessionUserTypeService, environment, document) {
        this._authQuery = _authQuery;
        this._authService = _authService;
        this._router = _router;
        this._snack = _snack;
        this._sessionUserTypeService = _sessionUserTypeService;
        this.environment = environment;
        this.document = document;
    }
    canLoad(route, segments) {
        this.requestParams = parseQueryParams(this.document.location.search.replace('?', ''));
        const path = (this.requestUrl = _map(segments, 'path').join('/'));
        return Observable.create((observer) => {
            const userInfo = this._authQuery.userInfo();
            if (!userInfo || !userInfo.id) {
                return this._authService.switchApp(observer);
                // this._authService.autologin().subscribe(() => {
                //   console.log('success');
                // });
                // if (!this._appropriateRole()) {
                //   return this._authService.autologin().pipe(
                //     catchError(() => {
                //       this._redirectToLogin(observer);
                //       return throwError(false);
                //     }),
                //     map(() => {
                //       return true;
                //     })
                //   );
                // } else {
                //   this._authService.switchApp(observer);
                //   return of(true);
                // }
            }
            else {
                if (!this._appropriateRole()) {
                    return of(this._authService.switchApp(observer));
                }
                else {
                    observer.next(true);
                    observer.complete();
                }
            }
        });
    }
    // private _autologin(path: string, observer: Subject<boolean>) {
    //   return this._authService.autologin().subscribe(() => {
    //     if (this._appropriateRole()) {
    //       this._router.navigate([`/d/${path}`]);
    //       observer.next(false);
    //       observer.complete();
    //     } else {
    //       this._authService.switchApp(observer);
    //     }
    //   });
    // }
    _appropriateRole() {
        var _a;
        return this.environment.role.includes((_a = this._authQuery.userInfo()) === null || _a === void 0 ? void 0 : _a.user_type);
    }
    _redirectToLogin(observer) {
        if (!this.environment.production) {
            this._router.navigate(['/a/login'], {
                queryParams: { requestUrl: this.requestUrl, requestParams: prepareQueryParams(this.requestParams) },
            });
        }
        else {
            window.location.href = `${location.origin}/auth?requestUrl=${this.requestUrl}&requestParams=${prepareQueryParams(this.requestParams)}`;
        }
        observer.next(false);
        observer.complete();
    }
};
AuthGuardService.ctorParameters = () => [
    { type: SessionQuery },
    { type: SessionService },
    { type: Router },
    { type: SnackbarService },
    { type: SessionUserTypeService },
    { type: undefined, decorators: [{ type: Inject, args: [AppEnvironment,] }] },
    { type: Document, decorators: [{ type: Inject, args: [DOCUMENT,] }] }
];
AuthGuardService = __decorate([
    Injectable(),
    __metadata("design:paramtypes", [SessionQuery,
        SessionService,
        Router,
        SnackbarService,
        SessionUserTypeService, Object, Document])
], AuthGuardService);
export { AuthGuardService };
